import { NavLink } from "react-router-dom";
import "../css/paintings.css";

interface CategoryLinkProps {
    target: string,
    file: string,
    title: string,
  }
  
export function CategoryLink({target, file, title}: CategoryLinkProps) {
    return (
      <div className="category-link">
        <NavLink to={target} ><img src={file} /></NavLink>
        <h1>{title}</h1>
      </div>
    );
  }
